<template>
    <button type="button" class="btn btn-primary-lighter m-1" @click="openModal">
        <span v-if="view_icon" class="material-symbols-outlined align-middle">
            visibility
        </span>
        {{ $trans.get(`__JSON__.${button_denomination}`) }}
    </button>
</template>

<script>

export default {
    setup() {
    },
    name: "OpenModalButton",
    created() {
    },
    props: {
        id_to_open: String,
        modal_to_open: String,
        payload: String,
        button_denomination: String,
        view_icon: Boolean,
    },
    data() {
        return {
            
        };
    },
    computed: {
    },
    mounted() {
    
    },
    methods: {
        openModal() {
            // console.log("view_icon: ", this.view_icon);
            let modal = '#' + this.modal_to_open;
            //console.log("show modal: ", modal);
            $(modal).modal("show");
        }
    }
};
</script>
